<template>
  <div class="form-workflow is-relative">
    <o-loading
        :full-page="true"
        v-model:active="isLoading"
        icon="rotate"
        icon-size="large"
    />
    <o-loading
        :full-page="false"
        v-model:active="disableEditForm"
    />

    <div class="title">Approval Workflow</div>
    <div class="subtitle">Optional for multi-step approval processes</div>

    <div class="box">
      <draggable v-model="formWorkflowSteps"
                 item-key="id"
                 tag="div"
                 :component-data="{name:'fade'}"
                 @start="drag=true"
                 @end="drag=false"
                 class="target-area"
                 :disabled="!canEdit"
                 v-if="formWorkflowSteps.length"
      >
        <template #item="{element, index}">
          <WorkflowStep class="is-draggable"
                        :form-workflow-step="element"
                        :step-number="index + 1"
                        :can-edit="canEdit"
                        :can-edit-if-allowed="canEditIfLocked"
                        :error-prefix="workflowStepErrorPrefix(index)"
                        :errors="errors"
          />
        </template>
      </draggable>

      <div v-else>
        Currently, there's no Workflow
      </div>
    </div>

    <WorkflowStep class="has-margin-top-large has-margin-left-large" v-if="canEdit" />

  </div>
</template>

<script setup>

  import draggable from 'vuedraggable';
  import _ from "lodash";

  import {
    userHasPermission,
    userIsRole
  } from "@/internal";

  import {computed, onMounted, ref, toRefs, watch} from "vue";

  import WorkflowStep from "./WorkflowStep.vue";

  const isLoading = ref(false);
  const formWorkflowSteps = ref([]);

  const props = defineProps({
    errors: {
      required: false,
      type: Array,
    },
    workflowSteps: {
      required: true,
      type: Array,
    },
    form: {
      required: true,
      type: Object,
    },
  });
  const {
    errors,
    workflowSteps,
    form,
  } = toRefs(props);

  const emit = defineEmits([
     'update',
  ]);

  const canEdit = computed(() => {
    return userHasPermission('form:update') && !form.value.form_locked && !form.value.archived;
  });

  const canEditIfLocked = computed(() => {
    return form.value.form_locked && !form.value.archived;
  });

  const disableEditForm = computed(() => {
    return !(canEdit.value || canEditIfLocked.value);
  });

  onMounted(() => {
    formWorkflowSteps.value = workflowSteps.value;
  });

  function workflowStepErrorPrefix(index) {
    return `workflow.workflowSteps.${index}`;
  }

  watch(() => _.cloneDeep(formWorkflowSteps.value), () => {
    emit('update', formWorkflowSteps.value);
  });

  watch(() => _.cloneDeep(workflowSteps.value), () => {
    formWorkflowSteps.value = workflowSteps.value;
  });

</script>

<style lang="scss" scoped>

.form-workflow {
  .is-draggable {
    cursor: move;
  }
}

</style>